import React from 'react';
import { CardSubtitle, CardTitle } from '@bexs/dollar/components/Card';
import Column from '@bexs/dollar/components/GridColumn';

const Title: React.FC = () => (
  <Column>
    <CardTitle>Download Report</CardTitle>
    <CardSubtitle>
      Enter the date you want to get the report and click do download.
    </CardSubtitle>
  </Column>
);

export default Title;
